//@ts-check

class CommonService {
	constructor($location, LocalStorageService) {
		this.$location = $location;
		this.LocalStorageService = LocalStorageService;

		this.deletedQueryStringParameters = [];

		this.init();
	}

	init() {
		this.apiRetry = {
			units: 'ms',
			value: 1800
		};
	}

	QueryString(queryStringName) {

		let deletedParameter = this.deletedQueryStringParameters.find(x => x == queryStringName);

		if(deletedParameter){
			return undefined;
		}

		let url = this.$location.absUrl().toLowerCase();
		let name = queryStringName.toLowerCase().replace(/[\[\]]/g, '\\$&');

		if (!url) {
			url = this.$location.absUrl().toLowerCase();
		}

		const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
			results = regex.exec(url);

		if (!results) return null;

		if (!results[2]) return '';

		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	async DeleteQueryStringParameter(queryStringParameterName) {
		this.deletedQueryStringParameters.push(queryStringParameterName);
		await this.$location.search(queryStringParameterName, null);
		await this.$location.$$compose();
	}

	get headersWithContentType() {
		const headers = this.headers;
		return {
			...headers,
			'content-type': 'application/json'
		};
	}

	get basicHeaders() {
		return {
			'content-type': 'application/json'
		};
	}

	get headers() {
		const userProfile = this.LocalStorageService.retrieve('userProfile');
		const sessionProfile = this.LocalStorageService.retrieve('userSession');

		const sessionToken = sessionProfile.SessionToken;
		const userName = userProfile.UserName || userProfile.WebUsername;

		if (!(sessionToken && sessionToken.length > 2) || !(userName && userName.length > 2)) {
			throw `Could not retrieve 'sessionToken' and\or 'userName' to send as the HTTP Headers`;
		}

		const headers = {
			userName,
			sessionToken
		};

		return headers;
	}

	get selectedBuildingRef() {
		let selectedBuilding;

		const selectedRef = this.LocalStorageService.retrieve('selectedBuildingRef');
		if (typeof selectedRef === 'object') {
			selectedBuilding = selectedRef.SchemeReference.trim();
		} else {
			selectedBuilding = selectedRef.trim();
		}
		if (!selectedBuilding) {
			let selectedBuildingRefQueryString = this.QueryString('DBRef');
			if (selectedBuildingRefQueryString) {
				this.selectedBuilding = selectedBuildingRefQueryString.toUpperCase();
			}
		}

		return selectedBuilding;
	}

	cleanUpStrings(text) {
		const cleanedString = text
			.trim()
			.replace(/[\n\r]+/g, ' ')
			.replace(/\s{2,}/g, ' ')
			.replace(/^\s+|\s+$/, '')
			.replace('*', '');

		return cleanedString;
	}
}

export default /* @ngInject */ ($location, LocalStorageService) => new CommonService($location, LocalStorageService);
